<template>
  <div class="container">
    <header>
      <nav style="padding-top: 15px; padding-bottom: 30px;">
        <div class="logo">
          <img src="../assets/logo.png" alt="">
        </div>
      </nav>
    </header>
    <div class="date">
      <div class="date-left" @click="prevResult">
        <img v-if="prevDraw" src="../assets/theme/prev.png" alt="">
      </div>
      <div class="date-center">
        <h1>{{ drawDate }}</h1>
      </div>
      <div class="date-right" @click="nextResult">
        <img v-if="nextDraw" src="../assets/theme/next.png" alt="">
      </div>
    </div>
    <h1>1st Prize</h1>
    <div class="bar-1">
      <ShowSlideNumbers length="5" :results="resultNumbers" result-key="prize_1st" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
    </div>
    <h1>2nd Prize</h1>
    <div class="bar-2">
      <ShowBalls length="5" :results="resultNumbers" result-key="prize_2nd" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
    </div>
    <h1>3rd Prize</h1>
    <div class="rd-3">
      <div class="rd-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="rd-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="rd-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="prize_3rd_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
    </div>
    <h1> Special</h1>
    <div class="specai">
      <div class="sp-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_5" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_6" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_7" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="sp-box">
        <ShowNumbers length="5" :results="resultNumbers" result-key="special_8" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
    </div>
    <h1>Consulation</h1>
    <div class="consulation">
      <div class="con-box">
        <ShowNumbers length="2" :results="resultNumbers" result-key="consolation_1" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="con-box">
        <ShowNumbers length="2" :results="resultNumbers" result-key="consolation_2" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="con-box">
        <ShowNumbers length="2" :results="resultNumbers" result-key="consolation_3" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
      <div class="con-box">
        <ShowNumbers length="2" :results="resultNumbers" result-key="consolation_4" :update-code="updateCode" :start-spin="startSpin" :start-show="startShow" :end-time="endTime" :slotCounting="slotCounting" :distance="distance" @changeSlot="calProcess" />
      </div>
    </div>
  </div>
</template>
<script>
import { slotItems } from '@/configs/slot.config.js'
import LottoService from '@/services/lottoService.js'
//import moment from 'moment'
import ShowNumbers from './components/ShowNumbers.vue'
import ShowBalls from './components/ShowBalls.vue'
import ShowSlideNumbers from './components/ShowSlideNumbers.vue'

export default {
  components: {
    ShowBalls,
    ShowNumbers,
    ShowSlideNumbers
  },
  data() {
    return {
      currentResult: null,
      currentResultId: null,
      prevDraw: null,
      nextDraw: null,
      today: this.$moment().format("YYYY-MM-DD"),
      IntervalReload: null,
      updateTime: null,
      setTimeoutToshow: null,
      setTimeoutToSuccess: null,
      distance: 10, // ระยะห่างของการออกแต่ล่ะเลข (วินาที)
      slotCounting: null,

      test1stResult: null
    }
  },
  watch: {
    startSpin(newVal, oldVal) {
      if(newVal && newVal !== oldVal) {
        this.updateTime = new Date().getTime()
      }
    },
    startShow(newVal, oldVal) {
      if(newVal && newVal !== oldVal) {
        this.calProcess()
      }
    },
    endTime(newVal, oldVal) {
      if(newVal && newVal !== oldVal) {
        this.updateTime = new Date().getTime()
      }
    },
    prize1st(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.updateTime = new Date().getTime()
      }
    },
    prize2nd(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.updateTime = new Date().getTime()
      }
    }
  },
  computed: {
    drawDate() {
      if (!this.currentResult)
        return '-'

      let date = this.$moment(this.currentResult.lotto_date)
      return date.format("YYYY-MM-DD") + `[${date.format("ddd")}]`
    },
    resultNumbers() {
      if (this.currentResult !== null) {
        return this.currentResult.results
      } else {
        return null
      }
    },
    updateCode() {
      return this.updateTime
    },
    startSpin() {
      if (this.currentResult !== null) {
        return this.currentResult.start_spin
      }
      return null
    },
    startShow() {
      if (this.currentResult !== null && this.currentResult.show_2nd) {
        return this.currentResult.show_2nd
      }
      return null
    },
    endTime() {
      if (this.currentResult !== null && this.currentResult.show_1st) {
        return this.currentResult.show_1st
      }
      return null
    },
    prize1st() {
      if (this.currentResult !== null && this.resultNumbers['prize_1st']) {
        return this.resultNumbers['prize_1st']
      }
      return null
    },
    prize2nd() {
      if (this.currentResult !== null && this.resultNumbers['prize_2nd']) {
        return this.resultNumbers['prize_2nd']
      }
      return null
    }
  },
  methods: {
    getResult(draw) {
      LottoService.getResult(draw).then((response) => {
        if (response.status === 'success') {
          this.currentResult = response.data
          this.prevDraw = response.prev
          this.nextDraw = response.next
        }
      })
    },
    prevResult() {
      this.currentResultId = this.prevDraw
      this.getResult(this.prevDraw)
    },
    nextResult() {
      this.currentResultId = this.nextDraw
      this.getResult(this.nextDraw)
    },
    reloadResult() {
      this.getResult(this.currentResultId)
    },
    calProcess() {
      if(this.setTimeoutToshow !== null) {
        clearTimeout(this.setTimeoutToshow)
      }
      if(this.currentResult.show_2nd) {
        // ยังไม่ถึงเวลาแสดงค่าแรก
        if(this.$moment().isBefore(this.currentResult.show_2nd)) {
          console.log('ยังไม่ถึงเวลาแสดงค่าแรก')
          this.slotCounting = null
          let diff = this.$moment(this.currentResult.show_2nd).diff(this.$moment(), 'milliseconds')
          this.setTimeoutToshow = setTimeout(() => {
            this.calProcess()
          }, diff)
        // ถึงเวลาแสดงค่าแรก
        }else{
          // ระยะเวลาหลังจากแสดงค่าแรก
          console.log('ระยะเวลาหลังจากแสดงค่าแรก')
          let diff = this.$moment().diff(this.$moment(this.currentResult.show_2nd), 'milliseconds')
          let slotIndex = Math.floor(Math.abs(diff) / (this.distance*1000))
          this.updateTime = new Date().getTime()
          if (slotIndex < slotItems.length) {
            this.slotCounting = slotItems[slotIndex]
            console.log('slotCounting#1', this.slotCounting, slotIndex)
          } else {
            this.slotCounting = slotItems[slotItems.length - 1]
            console.log('slotCounting#2', this.slotCounting)
          }
        }
      }
    },
  },
  created() {
    //console.log('created')
    this.getResult(this.currentResultId)
    this.IntervalReload = setInterval(() => {
      this.reloadResult()
    }, 45000)
  },
  beforeDestroy() {
    clearInterval(this.IntervalReload)
    clearTimeout(this.setTimeoutToshow)
    clearTimeout(this.setTimeoutToSuccess)
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Orbitron&display=swap');

* {
  margin: 0;
  padding: 0;
}

#app {
  margin: 0;
  padding: 0;
}

h1 {
  font-size: 25px;
  margin: 5px auto;
  font-weight: bold;
  color: #fff;
}

body {
  font-family: 'Orbitron', sans-serif;
  letter-spacing: 1px;
  text-align: center;
}

.logo {
  text-align: center;

  img {
    max-width: 60%;
  }
}

.container {
  max-width: 960px;
  height: auto;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  background: url('../assets/bg3.png') no-repeat left bottom;
  background-size: 100% auto;
  border: 1px solid #fff;
  padding-bottom: 100px;
  min-height: 1200px;
  border-top: 0;
  border-bottom: 0;
  background-color: #150C4B;
}

.orbitron {
  letter-spacing: 2px;
}

.date {
  width: 80%;
  height: 50px;
  margin: 5px auto;
  margin-bottom: 35px;
  display: flex;
  align-items: center;

  .date-center {
    //border:3px solid #222;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    display: flex;
    align-items: center;
    background: url('../assets/box-bg-c.png') repeat-x center;
    background-size: 13px 100%;
    margin-left: 13px;
    margin-right: 13px;
    position: relative;
    h1 {
      font-size: 40px;
      color: #000;
    }
  }

  .date-center:before {
    content: " ";
    background: url('../assets/box-bg-l.png') no-repeat center left;
    background-size: 100% 100%;
    position: absolute;
    width: 13px;
    left: -12px;
    height: 100%;
  }

  .date-center:after {
    content: " ";
    background: url('../assets/box-bg-r.png') no-repeat center right;
    background-size: 100% 100%;
    position: absolute;
    width: 13px;
    right: -12px;
    height: 100%;
  }

  .date-left {
    text-align: right;
    cursor: pointer;
    img {
      //margin-top: 10px;
      height: 35px;
      margin-right: 5px;
    }
  }

  .date-right {
    text-align: left;
    cursor: pointer;
    img {
      //margin-top: 10px;
      height: 35px;
      margin-left: 5px;
    }
  }
}

.bar-1 {
  margin-bottom: 35px;

  .ball-boxs {
    width: 100%;
    height: 100%;

    img {
      width: 33px;
      margin: 2px 5px;
    }

    .wloading {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      img {
        width: 33px;
        height: auto;
      }
    }
  }
}

.bar-2 {
  width: 450px;
  height: 60px;
  margin: 0 auto;
  padding: 0px;
  margin-bottom: 35px;
  display: flex;

  .ball-boxs {
    width: 100%;
    height: 100%;
    background: url('../assets/box-bg-c.png') repeat-x center;
    background-size: 10px 100%;
    margin-left: 10px;
    margin-right: 10px;
    position: relative;
    display: flex;
    align-items: center;

    img {
      width: 40px;
      margin: 2px 5px;
    }

    .wloading {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      img {
        width: 25px;
        height: auto;
      }
    }
  }

  .ball-boxs:before {
    content: " ";
    background: url('../assets/box-bg-l.png') no-repeat center left;
    background-size: 100% 100%;
    position: absolute;
    width: 13px;
    left: -12px;
    height: 100%;
  }

  .ball-boxs:after {
    content: " ";
    background: url('../assets/box-bg-r.png') no-repeat center right;
    background-size: 100% 100%;
    position: absolute;
    width: 13px;
    right: -12px;
    height: 100%;
  }
}

.rd-3 {
  width: 80%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 0.2rem;
  margin: 5px auto;
  margin-bottom: 15px !important;
}

.rd-box {
  width: auto;
  height: auto;
  border: 1px solid #000000;
  background-color: #ffffff;

  h1 {
    color: #000;
  }

  .wloading {
    .loading {
      width: 18px;
      margin: 12px 1px;
    }
  }
}

.specai {
  width: 80%;
  margin: 10px auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0.2rem;
  margin-bottom: 15px !important;
}


.sp-box {
  width: auto;
  /*height: 40px;*/
  border: 1px solid #000000;
  background-color: #ffffff;

  h1 {
    color: #000;
  }

  .wloading {
    .loading {
      width: 18px;
      margin: 12px 1px;
    }
  }
}

.consulation {
  width: 80%;
  margin: 10px auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 0.2rem;
}

.con-box {
  width: auto;
  /*height: 40px;*/
  border: 1px solid #000000;
  background-color: #ffffff;

  h1 {
    color: #000;
  }

  .wloading {
    .loading {
      width: 18px;
      margin: 12px 1px;
    }
  }
}

.banner-box {
  width: 80%;
}

.nav-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.nav-item img {
  display: none;
}

@media only screen and (max-width:768px) {

  .container {
    min-height: 1000px;
    background-size: unset;
  }

  .nav-item img {
    display: inline;
    margin: 15px 15px;
  }

  .nav-item img {
    width: 40px;
    height: 40px;
  }

  .logo {
    // margin-top: 15px;
    img {
      // height: 120px;
    }
  }
}

@media only screen and (max-width:700px) {
  .container {
    .bar-2 {
      height: 55px;
      .ball-boxs {
        img {
          width: 35px;
        }
      }
    }
  }
}

@media only screen and (max-width:600px) {
  .nav-grid {
    margin-bottom: 20px;
  }
  .logo {
    // margin-top: 10px;
    img {
      // height: 90px;
    }
  }
  .date, .bar-2, .rd-3, .specai, .consulation {
    width: calc(100% - 50px);
  }
  .container {
    .bar-2 {
      height: 50px;
      .ball-boxs {
        img {
          width: 30px;
        }
      }
    }
  }
}

@media only screen and (max-width:550px) {
  .logo {
    img {
      // height: 80px;
    }
  }
  .date {
    height: auto;
    .date-center {
      h1 {
        font-size: 24px;
      }
    }
    .date-left {
      img {
        height: 30px;
      }
    }
    .date-right {
      img {
        height: 30px;
      }
    }
  }
  .specai {
    .sp-box {
      h1 {
        font-size: 20px;
      }
      .wloading {
        .loading {
          width: 16px;
        }
      }
    }
  }
}

@media only screen and (max-width:500px) {
  .container {
    .bar-2 {
      height: 45px;
      .ball-boxs {
        img {
          width: 25px;
        }
      }
    }
  }
}

@media only screen and (max-width:450px) {
  .logo {
    img {
      //height: 65px;
    }
  }
  .date {
    .date-center {
      h1 {
        font-size: 24px;
      }
    }
  }
  .specai {
    .sp-box {
      h1 {
        font-size: 18px;
      }
      .wloading {
        .loading {
          width: 14px;
        }
      }
    }
  }
}

@media only screen and (max-width:400px) {
  .date {
    .date-center {
      h1 {
        font-size: 22px;
      }
    }
  }
  .rd-3 {
    .rd-box {
      h1 {
        font-size: 22px;
        letter-spacing: 1px;
      }
      .wloading {
        .loading {
          margin: 10px 1px;
        }
      }
    }
  }
  .specai {
    .sp-box {
      h1 {
        font-size: 16px;
        letter-spacing: 1px;
      }
      .wloading {
        .loading {
          width: 13px;
          margin: 8px 1px;
        }
      }
    }
  }
}

</style>
